import logo from "./logo.svg";
import React from "react";
import Header from "./components/sections/Header";
import Hero from "./components/sections/Hero";
import Problema from "./components/sections/Problema";
import Consecuencias from "./components/sections/Consecuencias";
import Solucion from "./components/sections/Solucion";
import ComoFunciona from "./components/sections/ComoFunciona";
import Resultados from "./components/sections/Resultados";
import FiltroCliente from "./components/sections/FiltroCliente";
import Proceso from "./components/sections/Proceso";
import Ejemplos from "./components/sections/Ejemplos";
import FAQ from "./components/sections/FAQ";
import FormularioCTA from "./components/sections/FormularioCTA";
import Footer from "./components/sections/Footer";
import "./styles/App.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Problema />
      <Consecuencias />
      <Solucion />
      <ComoFunciona />
      {/*<Resultados />*/}
      <FiltroCliente />
      <Proceso />
      <Ejemplos />
      <FAQ />
      <FormularioCTA />
      <Footer />

      {/* Aquí irán las demás secciones */}
    </div>
  );
}

export default App;
